import React from "react";
import { Result as AntdResult } from "antd";
import type { ResultProps as AntdResultProps } from "antd";

export type ResultProps = AntdResultProps;

const Result = AntdResult as unknown as React.ComponentType<ResultProps>;

export default Result;
